import React from "react";
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  StopOutlined,
  SwitcherOutlined
} from "@ant-design/icons";
import { Tag } from "antd";

export const StatusTag = ({ status } : { status: number }) => {
  switch (status) {
    case 0:
      return <Tag color='warning' icon={<ExclamationCircleOutlined />}>in review</Tag>;
    case 1:
      return <Tag color='success' icon={<CheckCircleOutlined />}>approved</Tag>;
    case 2:
      return <Tag color='error' icon={<StopOutlined />}>blocked</Tag>;
  }

  return <Tag color='default' icon={<SwitcherOutlined />}>unknown</Tag>;
}
